import { render, staticRenderFns } from "./requireLoading.vue?vue&type=template&id=012926f2"
import script from "./requireLoading.vue?vue&type=script&lang=js"
export * from "./requireLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports